import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { CircularProgress } from '@mui/joy';
import { Backdrop } from "@mui/material";

const dataProviderName = 'propertymanagement/property';
const model = 'propertymanagement/property';
const modelExposedName = 'property';
const wizardAction = 'create';

const Create = (params) => {
    const { t } = useTranslation();
    const { existingModules, userCapabilities } = useContext(AppContext);

    const [drawable, setDrawable] = useState(false);
    const { doAction, item, loadOne, errorMessage, errors, saving, success } = useDataProvider(dataProviderName, params.multipart);
    const { createConfig } = existingModules[dataProviderName];

    useEffect(() => {
        loadOne(null).then(() => setDrawable(true));
    }, []);

    const [editing, setEditing] = useState(false);

    useEffect(() => {
        if (success && editing) {
            (async () => {
                try {
                    await params.handleClose(params.uid, item.data);
                } catch (e) { }
            })();
        }
    }, [success]);

    const handleSave = async (data) => {
        doAction && doAction({ action: wizardAction, model: model ? model : dataProviderName, data: data });
    };

    return (
        !drawable ? <Backdrop open={!drawable} style={{ backgroundColor: "white" }}><CircularProgress /></Backdrop> :
            <DetailComponent
                disableDetailConfigOverride={true}
                values={{
                    ...item?.data,
                    product: 'sell',
                    price: 0,
                    country: 'IT',
                }}
                modelName={model.split('/')[1]}
                detailConfig={createConfig}
                dataProviderName={dataProviderName}
                onEditing={setEditing}
                save={handleSave}
                saving={saving}
                errors={errors}
                errorMessage={errorMessage}
                title={t('New {{itemname}}', { itemname: t(modelExposedName) })}
                canSave={userCapabilities && userCapabilities[dataProviderName + '.create']}
                header={
                    <InfoHeader
                        view="wizard"
                        title={t('Create new {{itemname}}', { itemname: t(modelExposedName) })}
                        subtitle={t('Fill the basic information to create a new {{itemname}} that you will be able to edit via the standard interface', { itemname: t(modelExposedName) })}
                    />
                }
                {...params}
            />
    );
};

export default Create;
